/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'filled-heart': {
    width: 25,
    height: 23,
    viewBox: '0 0 25 23',
    data: `<path class="st0" d="M18,0.4c-1.7,0-3.3,0.6-4.6,1.8c-0.4,0.3-0.7,0.7-0.9,1.1c-0.3-0.4-0.6-0.7-0.9-1.1C10.3,1.1,8.7,0.4,7,0.4
    c-3.6,0-6.5,2.9-6.5,6.5c0,2.2,0.6,4.3,1.9,6.5c1,1.6,2.3,3.3,4,4.8c2.8,2.6,5.6,4.1,5.7,4.1c0.1,0.1,0.3,0.1,0.5,0.1
    c0.2,0,0.3,0,0.5-0.1c0.1-0.1,2.9-1.5,5.7-4.1c1.7-1.5,3-3.2,4-4.8c1.2-2.1,1.9-4.3,1.9-6.5C24.5,3.3,21.6,0.4,18,0.4z"/>
  </svg>`
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/filled-heart.js